export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const OAUTH2_CLIENT_ID = process.env.REACT_APP_OAUTH2_CLIENT_ID;
export const API_URL = `${process.env.REACT_APP_BASE_URL}api/v1`;
export const HOCUS_POCUS_URL = `${process.env.REACT_APP_HOCUS_POCUS_URL}`;
export const HOCUS_POCUS_API_URL = `${process.env.REACT_APP_HOCUS_POCUS_URL}v1`;
export const HOCUS_POCUS_HTTP_API_URL = "http://localhost:8000/api/v1";
export const MERIDIAN_EMAIL_CONNECTIONS_URL = `${process.env.REACT_APP_BASE_URL}email-calendar-sync?tab=Email%20Connections`;
export const REACT_QUERY_ERROR = "ReactQueryError";

export const DEBOUNCE_MS = 320;
export const ANIMATION_DURATION_IN_MS = 150;
export const UI_TRANSITION_DELAY_MS = 800;

export const DEFAULT_NOTE_TITLE = "Untitled note";

export const GOOGLE_ACCOUNT_CHOOSER_URL = "https://accounts.google.com/AccountChooser?continue=";
export const GOOGLE_MAIL_DOMAIN = "mail.google.com";
export const GOOGLE_CALENDAR_DOMAIN = "calendar.google.com";

export const OUTLOOK_DOMAINS: readonly string[] = [
  "microsoft.com",
  "www.microsoft.com",
  "login.microsoftonline.com",
  "outlook.cloud.microsoft",
  "outlook.live.com",
  "outlook.office.com",
  "outlook.office365.com",
];

export const OUTLOOK_ADDIN_URL =
  "https://marketplace.microsoft.com/en-us/product/office/WA200008008";

export const TOOLS_API_URL = process.env.REACT_APP_TOOLS_API;

export const MAINTENANCE_RECOVERY_POLL_MS = 30_000;
export const MAINTENANCE_STATUS_POLL_MS = 300_000;
export const MAINTENANCE_STATUS_TIMEOUT_MS = 3_000;
export const MAINTENANCE_503_STREAK_THRESHOLD = 3;

export const HTTP_PROTOCOL = "http://";
export const HTTPS_PROTOCOL = "https://";

/**
 * Prepends the "Bearer" scheme to an access token for use in HTTP Authorization headers.
 *
 * @param token - The raw access token string.
 * @returns The token formatted as a Bearer token (e.g., "Bearer eyJhbGciOi...").
 */
export const createBearerToken = (token: string): string => `Bearer ${token}`;

export const SWITCHES = {
  COMMENTS_AND_REPLIES: "Comments & Replies",
  COMPANIES_AND_PEOPLE: "Companies & People",
  COMPANIES_V2: "Companies V2",
  DATA_VIEW_EXPORT: "Data View Export",
  DEAL_SOURCE_SUPPLEMENTAL: "Deal Source Supplemental Fields",
  DEAL_SOURCE: "Deal Source",
  DOCUMENT_STORAGE: "Document Storage",
  EMAIL_CONTEXT_WINDOW: "Email Context Window",
  FAMILIAR_NAME: "Familiar name",
  FUNDS_AND_OPPORTUNITIES: "Funds And Opportunity Module",
  IC_MEETING_AGENDA: "IC Meeting Agenda",
  MULTIPLE_ACTIVE_DEALS: "Multiple Active Deals",
  NOTES_GLOBAL: "notes_global",
  ONBOARDING_DEMO: "Onboarding Demo",
  OUTLOOK_PLUGIN: "Outlook plugin",
  OUTLOOK_SYNC_CONTACTS: "Outlook Sync (People)",
  OUTLOOK_SYNC_MEETING: "Outlook Sync (Meetings)",
  PEOPLE_V2: "People V2",
  PIPELINE_V2: "Pipeline V2",
  SCOUT_V2: "Scout V2",
  STOCK_MARKET: "StockMarket",
  THEMATIC_SOURCING_ACTIVITIES_DONT_TOUCH: "Enable TS activities (DONT TOUCH)",
  THEMATIC_SOURCING_DEALS: "Thematic Sourcing: Deals Tab",
  THEMATIC_SOURCING_DOCUMENTS: "Thematic Sourcing: Documents Tab",
  THEMATIC_SOURCING: "Thematic Sourcing",
};

export const MAX_FILE_SIZE_MB = 100;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

// Formats accepted for IC Memo / CIM uploads on Deal creation. Bare extensions
// (no leading dot) — matches `attachment.format` values. The `accept` attribute
// string is derived for the file picker; file-upload helpers consume the array
// directly for MIME validation, the dropzone label, and email-attachment filtering.
export const DEAL_DOC_ACCEPT_FORMATS: readonly string[] = ["pdf", "docx", "doc", "pptx", "ppt"];
export const DEAL_DOC_ACCEPT_ATTRIBUTE = DEAL_DOC_ACCEPT_FORMATS.map((f) => `.${f}`).join(", ");

/* This regex supports format: Juan Pérez <juan.perez@example.com> and single valid emails string. */
export const EMAIL_VALIDATION_REGEX =
  /^(?:([^<]+?)\s*<([^@<>\s]+@[^@<>\s]+\.[^@<>\s]+)>|([^@<>\s]+@[^@<>\s]+\.[^@<>\s]+))$/;

/**
 * Regular expression pattern used to match citations in a conversation.
 * The pattern matches any string that starts and ends with double parentheses,
 * and contains one or more digits in between.
 *
 * Example: ((123)), ((1)(2)(3)), ((1))((2))((3))
 */
export const CITATION_REGEX = /\(\((\d+(?:\)\(\d+)*)\)\)/g;

import { MeetingType } from "@enums/meetings.enum";

export const MEETING_TYPES = [
  {
    color: "#EAB308",
    value: MeetingType.INVESTMENT_COMMITTEE,
    label: MeetingType.INVESTMENT_COMMITTEE,
    type: MeetingType.INVESTMENT_COMMITTEE,
  },
  {
    color: "#10B981",
    value: MeetingType.PIPELINE_REVIEW,
    label: MeetingType.PIPELINE_REVIEW,
    type: MeetingType.PIPELINE_REVIEW,
  },
  {
    color: "#EF4444",
    value: MeetingType.MEETING,
    label: MeetingType.MEETING,
    type: MeetingType.MEETING,
  },
];

export const MEETING_TOOLTIP_TEXT = {
  private: "Only you and attendees have access to this meeting",
  shared: "Everyone can see this meeting",
};

export const AVAILABLE_GROUP_LABELS_FOR_PIPELINE_STAGE_SELECT = {
  NO_STAGE: "No Stage",
  PROSPECT_PIPELINE: "Prospect Pipeline",
  DEAL_PIPELINE: "Deal Pipeline",
  PORTFOLIO_PIPELINE: "Portfolio Pipeline",
};
